/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';

const Page = () => {

    const { ApiBasUrl } = useContext(MyContext);

    const [pagelist, setPageList] = useState([]);
    const [loading, setLoading] = useState(true);

    const perams = useParams();
    const Title = perams.title?.replaceAll('_', ' ');

    useEffect(() => {
        setLoading(true);
        axios.post(`${ApiBasUrl}/pagelist.php`)
            .then((res) => {
                setPageList(res.data.pagelist);
                setLoading(false);
            })
            .catch((error) => {
                console.error("pagelist.php", error);
            });
    }, [perams]);

    return (
        <div>
            <div className="">
                {loading
                    ? <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center">
                        <div className="loader2"></div>
                    </div>
                    : <div className='width_container'>
                        {
                            pagelist?.map((item, index) => {
                                if (item.title.toLowerCase() === Title.toLowerCase()) {
                                    return (
                                        <div key={index}>
                                            <h3 className='text-[20px] font-[500]'>{item.title}</h3>
                                            <p className='p-[20px]' dangerouslySetInnerHTML={{ __html: item?.description }} />
                                        </div>
                                    );
                                }
                                return null;
                            })
                        }
                    </div>}
            </div>
        </div>
    )
}

export default Page;
/* jshint ignore:end */